import React from 'react';
import Helmet from 'react-helmet';

const Page = ({ title, link, description, children }) => {
  let meta = [
    { name: "apple-mobile-web-app-title", content: title },

  ];

  description = description || `Website for ${title}`;
  meta.push({ name: "description", description });

  return (
    <div className="page">
      <Helmet title={title} link={link} meta={meta} />
      {children}
    </div>
  );
};

export default Page;


// WEBPACK FOOTER //
// ./src/pages/Page.js